import { render, staticRenderFns } from "./AnswersIndex.vue?vue&type=template&id=6b03cf5b&scoped=true&"
import script from "./AnswersIndex.vue?vue&type=script&lang=js&"
export * from "./AnswersIndex.vue?vue&type=script&lang=js&"
import style1 from "./AnswersIndex.vue?vue&type=style&index=1&id=6b03cf5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b03cf5b",
  null
  
)

export default component.exports